import { render, staticRenderFns } from "./PesertaButton.vue?vue&type=template&id=79a29746&"
import script from "./PesertaButton.vue?vue&type=script&lang=js&"
export * from "./PesertaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports